<template>
  <Modal :open.sync="open" size="small">
    <div class="dwp-space-y-3">
      <div
        class="dwp-text-xl dwp-font-medium dwp-flex dwp-items-center dwp-space-x-2"
      >Add a new list</div>
      <TextInput
        ref="form"
        placeholder="Enter a list name"
        @keydown.enter.native="submit"
        v-model="form.title"
      />
      <VButton @click.native="submit">Add List</VButton>
      <VButton type="plain" @click.prevent.native="open = false">Cancel</VButton>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import { sync } from "vuex-pathify";
import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],
  components: {
    Modal,
    TextInput,
    VButton,
  },

  data() {
    return {
      form: {
        title: "",
      },
    };
  },

  watch: {
    // focus after open
    open(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.form.focus();
        });
      }
    },
  },

  mounted() {
    if (this.open) {
      this.$nextTick(() => {
        this.$refs.form.focus();
      });
    }
  },

  computed: {
    open: sync("ui/modal@list.new.open"),
    loading: sync("ui/loading"),
    menu: sync("ui/slideMenu"),
  },

  methods: {
    async submit() {
      this.open = false;
      this.menu = false;
      this.loading = true;
      let id = await this.$store.dispatch("lists/addList", {
        title: this.form.title,
      });
      this.loading = false;
      this.form.title = "";
      this.$nextTick(() => {
        this.currentListId = id;
      });
    },
  },
};
</script>